import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { Order } from '../models/order.model';
import { LoggerService } from './logger.service';
import { SessionService } from './session.service';
import { WindowRefService } from './window.service';

@Injectable()
export class WorkticketService {
	constructor(
		private http: HttpClient,
		private sessionService: SessionService,
		private configService: ConfigService,
		private windowRefService: WindowRefService,
		protected logger: LoggerService,
		protected translateService: TranslateService
	) {}

	/**
	 * Open a work ticket for a specific order in a separate tab
	 */
	showWorkticket(order: Order): Observable<boolean> {
		return new Observable<boolean>((subscriber) => {
			// Get workticket link
			this.getWorkticketLink(order).subscribe(
				(workticketUrl: string) => {
					const header = {
						Authorization: 'Bearer ' + this.sessionService.session.accessToken
					};

					this.http.get(workticketUrl, { headers: header, responseType: 'blob' }).subscribe((blob) => {
						const url = window.URL.createObjectURL(blob);

						const tab = this.windowRefService.newTab;

						if (tab) {
							if (url) {
								// Open link
								tab.location = url;
							} else {
								// Show error page
								tab.location = this.windowRefService.baseUrl + '/external/error';
							}

							// Return true
							subscriber.next(true);
							subscriber.complete();
						} else {
							subscriber.error([new Error('Cannot open new Tab'), url]);
						}
					});
				},
				(err: any) => {
					// Return error
					this.logger.error(err);
					subscriber.error(err);
				}
			);
		});
	}

	downloadWorkticket(order: Order): Observable<boolean> {
		return new Observable<boolean>((subscriber) => {
			this.getWorkticketLink(order).subscribe(
				(workticketUrl: string) => {
					try {
						const header = {
							Authorization: 'Bearer ' + this.sessionService.session.accessToken
						};

						this.http.get(workticketUrl, { headers: header, responseType: 'blob' }).subscribe((blob) => {
							const url = window.URL.createObjectURL(blob);
							const windowOpened = this.windowRefService.openUrl(url);
							if (windowOpened) {
								subscriber.next();
								subscriber.complete();
							} else {
								subscriber.error(new Error('Cannot open new Tab'));
							}
						});
					} catch (err) {
						subscriber.error(err);
					}
				},
				(err) => {
					subscriber.error(err);
				}
			);
		});
	}

	private getWorkticketLink(order: Order): Observable<string> {
		return new Observable<string>((subscriber) => {
			this.sessionService.check().subscribe(
				() => {
					// Data for request
					const sessionId = this.sessionService.session.uid || '';
					const culture = this.translateService.currentLang === 'resources' ? 'en-GB' : this.translateService.currentLang;
					let url =
						`${this.configService.config.workticketUri}/Workticket/Controller/Download/` +
						`SIRONA_Connect_Order_${order.orderNumber}.pdf` +
						`?orderId=${order.uid}&sessionId=${sessionId}` +
						`&culture=${culture}`;

					subscriber.next(url);
					subscriber.complete();
				},
				(err) => {
					this.logger.error(err);
					subscriber.error(err);
				}
			);
		});
	}
}
